import produce from 'immer';

import {
  AGENCY_PREFERENCES_EDIT_FAILURE,
  AGENCY_PREFERENCES_EDIT_SUCCESS,
  AGENCY_PREFERENCES_FETCH_FAILURE,
  AGENCY_PREFERENCES_FETCH_SUCCESS,
} from '@actions/agencyPreferences';

const initialState: IAgencyPreferencesStore = {
  contactPreferenceNote: '',
  isFetching: true,
  error: null,
};

export default (state: IAgencyPreferencesStore = initialState, action: any) =>
  produce(state, (draftState: IAgencyPreferencesStore) => {
    switch (action.type) {
      case AGENCY_PREFERENCES_FETCH_SUCCESS:
      case AGENCY_PREFERENCES_EDIT_SUCCESS:
        draftState.contactPreferenceNote = action.response.contactPreferenceNote;
        draftState.error = null;

        return;

      case AGENCY_PREFERENCES_FETCH_FAILURE:
        draftState.error = action.error;

        return;

      case AGENCY_PREFERENCES_EDIT_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
